import { InjectionToken } from '@angular/core';

export interface ErrorHandlerConfig {
	useErrorHandlers: Array<any>;
}

export const ErrorHandlerConfigService = new InjectionToken<ErrorHandlerConfig>('ErrorHandlerConfig');
